<ng-template #content let-p>
  <mat-icon class="planta__ic" fontSet="material-icons" aria-hidden="true">warehouse</mat-icon>
  <div class="planta__txt">
    <span class="planta__val" [title]="p.plantDescription + ' · ' + p.companyDescription">
      <b>{{ p.plantDescription || '' }}</b>
      <span>({{ p.companyDescription || 'Compañía' }})</span>
    </span>
  </div>
</ng-template>

@if (ctx.active(); as p) {
  @if (ctx.plants().length > 1) {
    <button type="button" class="planta planta--btn" aria-label="Cambiar de planta" [matMenuTriggerFor]="menu">
      <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: p }" />
      <mat-icon class="planta__ic planta__arrow" fontSet="material-icons" aria-hidden="true">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @for (pl of ctx.plants(); track pl.companyCode + '-' + pl.plantCode) {
        <button mat-menu-item type="button" (click)="selectPlant(pl)">
          {{ pl.plantDescription || '' }} ({{ pl.companyDescription || 'Compañía' }})
        </button>
      }
    </mat-menu>
  } @else {
    <div class="planta" role="group" aria-label="Planta">
      <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: p }" />
    </div>
  }
}
